import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuth, AuthProvider } from './hooks/useAuth';
import { Dashboard } from './components/Dashboard/Dashboard';
import { LoginForm } from './components/Auth/LoginForm';
import { NFCTimeTracking } from './components/NFC/NFCTimeTracking';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-base-100">
        <span className="loading loading-spinner loading-lg text-primary"></span>
        <p className="mt-4 text-base-content">Laden...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public NFC Route - no authentication required */}
        <Route path="/nfc" element={<NFCTimeTracking />} />
        
        {/* Protected Routes */}
        <Route path="/*" element={
          !user ? <LoginForm /> : <Dashboard user={user} />
        } />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;